var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video",attrs:{"id":_vm.element.id}},[_c('youtube',{ref:"youtube",attrs:{"video-id":_vm.src,"player-vars":_vm.playerVars}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }